import React, { Fragment, useState, useEffect } from "react";
import Navbar from "../../Navbar";
import Footer from "../../Footer";
import { useTranslation } from 'react-i18next';
// import travelimg from '../tr.png';
import { Container, Form, Row, Col, Card, Button, CardBody } from "react-bootstrap";
import Cookies from 'js-cookie';
import MedicalAffordableRemove from "../../helper/medicalaffordable";
const { config } = require('../../api/api');



function MedicalAffordableDownload() {
  const base_url = config.baseURL;
  const redirect_url = config.redirectURL;
  const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();

  const [vendorKey, setVendorkey] = useState('');
  const [dhofarData, setDhofarData] = useState(false);
  const [downloadpolicy, setDownloadValue] = useState('');
  const [policyLink, setPolicyLink] = useState(null);
  const [policyBase64, setPolicyBase64] = useState(null);
  const [policy_no, setPolicyNo] = useState(null);
  const [age, setAge] = useState(null);
  const [isPaid, setIsPaid] = useState(null);
  const [payment_link, setPaymentValue] = useState('');
  const [passportFile, setPassportFile] = useState(null);
  const [questionnaireFile, setQuestionnaireFile] = useState(null);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [fileChoosen,setFileChoosen]=useState(true);
  const [fileupload, setFileupload] = useState('');
  

  const pattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+)(:[0-9]{1,5})?(\/.*)?$/;

  useEffect(() => {
    const urlSearchString = window.location.search;
    const uparams = new URLSearchParams(urlSearchString);
    const policy_no = uparams.get('policyno');
    setPolicyNo(policy_no);
  }, []);


  useEffect(() => {
    const createOrganization = async () => {
      try {
        const postvData = { organization_name: "Superjet" };

        const response = await fetch(base_url + '/create_organization', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(postvData),
        });
        const data = await response.json();
        setVendorkey(data.result[0].vendor_key);
      } catch (error) {
        console.error('Error posting data:', error);
      }
    };

    if (!vendorKey) {
      createOrganization();
    }
  }, [vendorKey, base_url]);

  useEffect(() => {
    const createToken = async () => {
      if (vendorKey) {
        try {
          const response = await fetch(base_url + '/create_dhofar_tcs_token', {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${vendorKey}`,
            },
          });
          const data = await response.json();
          const dhdata = data.result.data.token;
          setDhofarData(dhdata);
        } catch (error) {
          console.error('Error getting token:', error);
        }
      }
    };

    createToken();
  }, [vendorKey, base_url]);

    useEffect(() => {
      if (!vendorKey || !dhofarData || !policy_no) return;
      const fetchAllPolicyDetails = async () => {
        const payload = { token: dhofarData, policy_no };
        try {
          const paymentRes = await fetch(base_url + '/get_dhofar_him_policy_details', {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${vendorKey}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });
          const paymentData = await paymentRes.json();
          setIsPaid(paymentData.result.data.payments.isPaid);
  
          
        } catch (error) {
          console.error('Error fetching policy details:', error);
        }
      };
      fetchAllPolicyDetails();
    }, [vendorKey, dhofarData, policy_no, base_url]);

  useEffect(() => {
    
    const fetchPolicyDetails = async () => {
      if (vendorKey && dhofarData && policy_no) {
        try {
          const quotation_data = {
            token: dhofarData,
            policy_no: policy_no,
          };

          const response = await fetch(base_url + '/get_ahc_policydetails', {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${vendorKey}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(quotation_data),
          });

          const data = await response.json();
          
          setDownloadValue(data.result[0]);
          setFileupload(data.result[0].file_upload);
          const postData1 = { token: dhofarData, policy_no: policy_no };
          const response2 = await fetch(base_url + '/get_ahc_policydocument', {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${vendorKey}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(postData1),
          });
          const data2 = await response2.json();

          if (data2.message === 'success') {
            const resultData = data2.result.data;
            if (typeof resultData === 'string') {
              setPolicyBase64(resultData);
              setPolicyLink('');
            } else {
              setPolicyLink(resultData?.policy_schedule_url || '');
              setPolicyBase64(null);
            }
          } else {
            setPolicyLink('');
            setPolicyBase64(null);
          }
        } catch (error) {
          console.error('Error fetching policy details:', error);
        }
      }
    };

    fetchPolicyDetails();
  }, [vendorKey, dhofarData, policy_no, base_url]);
  const handleQotation = async (event) => {



    

    var quotation_data =
    {
      "token": dhofarData,
      "policy_no": policy_no,
      "redirect_url": redirect_url + '/medicalhealth-download?policyno=' + policy_no
    };
    
    if (vendorKey !== '') {
      // const fetchPolicy = async () => {
      try {

        setLoading(true);
        const Policyresponce = await fetch(base_url + '/get_ahc_paymentlink', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${vendorKey}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(quotation_data),
        });

        if (!Policyresponce.ok) {
          throw new Error('Network response was not ok');
        }
        

        const data = await Policyresponce.json();

        setPaymentValue(data.result.data.payment_url);
        window.location.href = data.result.data.payment_url;
        //   await handlePolicy(data.result.data.amount)
      } catch (error) {
        setLoading(false);
        console.error('Error fetching occupations:', error);
      }
      // };


    }
  };
          const basedownload = async () => { 
                            if (policyLink) {
                              const link = document.createElement('a');
                              link.href = policyLink;
                              link.target = '_blank';
                              link.download = policyLink.split('/').pop();
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            } else if (policyBase64) {
                              const byteChars = atob(policyBase64);
                              const byteArr = new Uint8Array([...byteChars].map(c => c.charCodeAt(0)));
                              const blob = new Blob([byteArr], { type: 'application/pdf' });
                              const url = URL.createObjectURL(blob);
                              const link = document.createElement('a');
                              link.href = url;
                              link.download = `policy_${policy_no}.pdf`;
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                              URL.revokeObjectURL(url);
                            }
                          };
  const handledownload = async () => {
    var datas={
      'token':dhofarData,
      'policy_no':policy_no
    };
    
      if (vendorKey !== "") {
        setLoading(true);
        try {
          const response = await fetch(base_url + "/medical_documents", {
            method: "POST",
            headers: {
              "Authorization": `Bearer ${vendorKey}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(datas),
            responseType: "blob", // Fetch response as a binary file
          });
    
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
    
          // Convert response to blob
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
    
          // Create a download link
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", policy_no+".pdf"); // Ensure correct file type
          document.body.appendChild(link);
          link.click();
          setLoading(false);
    
          // Cleanup
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
    
        } catch (error) {
          setLoading(false);  
          console.error("Error generating quotation PDF:", error);
        }
      }
    };



  const handleSubmit = async (event) => {
    event.preventDefault();
    MedicalAffordableRemove();
    window.location.href = '/insurance';

  };

  const handlerepayment = async (event) => {
    // event.preventDefault();
    handleQotation();
  }

      useEffect(() => {
        if (showUploadModal) {
          document.body.style.overflow = 'hidden'; 
        } else {
          document.body.style.overflow = 'auto';
        }
        
        return () => {
          document.body.style.overflow = 'auto'; 
        };
      }, [showUploadModal]);


  const isValidUrl = (url) => {
    return pattern.test(url);
  };
  const handleUpload = async (e) => {
      e.preventDefault();
      const dhofar = dhofarData;
      const policy = policy_no;
      const formData = new FormData();
      formData.append('token', dhofar);
      formData.append('policy_no', policy);
  
      if (passportFile !== null) {
        formData.append('passport', passportFile);
      }
  
      if (questionnaireFile !== null) {
        formData.append('sponsor_id', questionnaireFile);
      }
      setLoading(true);
      const response = await fetch(base_url + '/get_ahc_fileupload', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${vendorKey}`
        },
        body: formData
      });
      const data = await response.json();
      if (data.result.success) {
        alert(data.result.message);
        setLoading(false);
        getdetails();
      } else {
        setLoading(false);
        alert('file is not uploaded try again');
      }
    };
  
    const handleFileChange = (e) => {
      // ;
      if (e.target.files.length === 1) {
        const file = e.target.files[0];
        const name = e.target.name;
        const fileType = file.type;
        const maxSize = 2 * 1024 * 1024; // 5MB in bytes
  
        // Check if the file exceeds the size limit
        if (file && file.size > maxSize) {
          alert('File size exceeds the 2MB limit.');
          return;
        }
  
        if (fileType.startsWith('image') || fileType === 'application/pdf') {
          if (name === 'passport' && passportFile == null) {
            if (fileType === 'application/pdf' || fileType.toLowerCase().endsWith('jpg')||fileType.toLowerCase().endsWith('jpeg')||fileType.toLowerCase().endsWith('png')){
              setPassportFile(file);
            }else{
              alert('Upload PDF or image format')
            }
          } else if (name === 'passport' && passportFile !== null && passportFile !== '' && passportFile !== undefined) {
            setPassportFile(null);
            if (fileType === 'application/pdf' || fileType.toLowerCase().endsWith('jpg')||fileType.toLowerCase().endsWith('jpeg')||fileType.toLowerCase().endsWith('png')){
              setPassportFile(() => file);
            }else{
              alert('Upload PDF or image format')
            }
          } else if (name === 'questionnaire' && questionnaireFile == null) {
            setQuestionnaireFile(file);
          } else if (name === 'questionnaire' && questionnaireFile !== null && questionnaireFile !== '' && questionnaireFile !== undefined) {
            setQuestionnaireFile(null);
            setQuestionnaireFile(() => file);
          }
        } else {
          alert('Please select a valid image or PDF file.');
        }
        document.getElementById('passport').value = '';
        document.getElementById('questionnaire').value = '';
      }
    };
    const handleFileDelete = (e) => {
      // ;
      const name = e.target.getAttribute('data-name');
      if (name === 'questionnaire') {
        setQuestionnaireFile(null);
        document.getElementById('questionnaire').value = '';
      } else if (name === 'passport') {
        setPassportFile(null);
        document.getElementById('passport').value = '';
      }
    };
  
    const handleClose = () => {
      setShowUploadModal(false);
    };
  
    const handleShow = () => {
      setShowUploadModal(true);
    };
    useEffect(()=>{
    if((passportFile!==null&& passportFile!==undefined && passportFile!=="")&&
    (questionnaireFile!==null&& questionnaireFile!==undefined && questionnaireFile!=="")){
      setFileChoosen(false);
    }
    else{
      setFileChoosen(true);
    }
  },[passportFile,questionnaireFile]);


  const getdetails = async () => {
    try {
      const ddata = {
        token: dhofarData,
        policy_no: policy_no,
      };

      const response = await fetch(base_url + '/get_ahc_policydetails', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${vendorKey}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(ddata),
      });

      const data = await response.json();
      setDownloadValue(data.result[0]);
      setFileupload(data.result[0].file_upload);
      } catch (error) {
        console.error('Error fetching occupations:', error);
      }
        
  };

  return (



    <Fragment>

      <div className="header_section1">

        <Navbar />


        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">{(lnstr === 'en') ? 'Download Policy - ' + policy_no : 'تحميل السياسة\n'}</h3>
          </div>
        </div>


      </div>


      {/* <div className="features_section">
        <div className="container">

          <div className="row">

            <Col md={3}></Col>

            <Col md={6} className="myforms my-5" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

              <br />

              <table className="table table-bordered table-condenced" style={{ textAlign: 'left' }}>

                <tbody>

                  <tr><td style={{ width: '50%' }}><b>{t("Name")}</b>
                  </td><td>{downloadpolicy != null ? downloadpolicy?.first_name : ''}</td></tr>

                  <tr><td><b>{t("Email")}</b>
                  </td><td>{downloadpolicy != null ? downloadpolicy?.email : ''}</td></tr>

                  <tr><td><b>{t("Mobile Number")}</b>
                  </td><td>{downloadpolicy != null ? downloadpolicy?.mobile_no : ''}</td></tr>


                  <tr><td><b>{t("Insurance")}</b>
                  </td><td>{downloadpolicy != null ? downloadpolicy?.insurance_type : ''}</td></tr>



                  <tr><td><b>{t("Plan")}</b>
                  </td><td>{downloadpolicy != null ? downloadpolicy?.type : ''}</td></tr>

                  <tr><td><b>{t("Fees")}</b>
                  </td><td>{downloadpolicy != null ? downloadpolicy?.fee: ''}</td></tr>




                </tbody>

              </table>

              <div className="col-12 d-flex flex-column align-items-center">

              {policyLink != null && policyLink !== '' && fileupload != 'yes' && <div className="row w-100 justify-content-center">
                  <div className="col-lg-4 col-md-4 col-sm-8 col-8 p-1 mb-2 d-flex justify-content-center" style={{ width: '33%' }}>
                    <button type="button" className="btn btn-primary " onClick={handleShow}>
                      {t("Upload")} {t("Documents")}
                    </button>
                  </div>
                </div>
                }
                  {policyLink != null && policyLink !== '' ? (
                    fileupload == 'yes' ? (<div className="row w-100 justify-content-between">

                      
                      <div className="col-lg-4 col-md-4 col-sm-8 col-8 p-1 mb-2 d-flex justify-content-center" >
                        <button className="btn btn-primary"
                          onClick={() => {
                            handledownload();
                            
                          }}
                        >
                          {t("Download")} {t("Policy")}
                        </button>
                      </div>

                      
                      <div className="col-lg-4 col-md-4 col-sm-8 col-8 p-1 mb-2 d-flex justify-content-center" style={{ width: '33%' }}>
                        <button className="btn btn-primary w-100" onClick={handleSubmit}>
                          {t("Go To Home")}
                        </button>
                      </div>

                     

                    </div>) : ''
                  ) : policyLink === '' ? (
                    <div className="text-center">
                      <h2>{t("Policy")} {t("Payment")} {t("Pending")}</h2>
                      <div>
                        <button onClick={handlerepayment}
                          style={{ marginLeft: 'auto', fontWeight: 'bold', backgroundColor: '#3fd2f2', color: 'white' }}>
                         {t("Make Payment")}
                        </button>
                      </div>
                    </div>
                  ) : "Loading"
                }
</div>

            </Col>
            <Col md={2}></Col>
          </div>
        </div>
      </div> */}
      <div className="features_section">
              <div className="container">
                <div className="row">
                  <Col md={3}></Col>
                  <Col md={6} className="myforms my-5" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <br />
                    <table className="table table-bordered table-condenced" style={{ textAlign: 'left' }}>
                      <tbody>
                        <tr>
                          <td style={{ width: '50%' }}><b>{t("Name")}</b></td>
                          <td>{downloadpolicy?.first_name || ''}</td>
                        </tr>
                        <tr>
                          <td><b>{t("Email")}</b></td>
                          <td>{downloadpolicy?.email || ''}</td>
                        </tr>
                        <tr>
                          <td><b>{t("Mobile Number")}</b></td>
                          <td>{downloadpolicy?.mobile_no || ''}</td>
                        </tr>
                        <tr>
                          <td><b>{t("Insurance")}</b></td>
                          <td>{downloadpolicy?.insurance_type || ''}</td>
                        </tr>
                        <tr>
                          <td><b>{t("Plan")}</b></td>
                          <td>{downloadpolicy?.type || ''}</td>
                        </tr>
                        <tr>
                          <td><b>{t("Fees")}</b></td>
                          <td>{downloadpolicy?.fee  || ''}</td>
                        </tr>
                      </tbody>
                    </table>
      
                    <div className="col-12 d-flex flex-column align-items-center">
                      {isPaid === null ? 'Loading' : isPaid ? (
                        fileupload === 'yes' && (policyLink || policyBase64) ? (
                          <div className="row w-100 justify-content-between">
                            <div className="col-lg-4 col-md-4 col-sm-8 col-8 p-1 mb-2 d-flex justify-content-center" style={{ width: '33%' }}>
                              <button className="btn btn-primary w-100" onClick={basedownload}>
                                {t("Download")} {t("Policy")}
                              </button>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-8 col-8 p-1 mb-2 d-flex justify-content-center" style={{ width: '33%' }}>
                              <button className="btn btn-primary w-100" onClick={handleSubmit}>
                                {t("Go To Home")}
                              </button>
                            </div>
                          </div>
                        ) : fileupload === 'no' ? (
                          <div className="row w-100 justify-content-center">
                            <div className="col-lg-4 col-md-4 col-sm-8 col-8 p-1 mb-2 d-flex justify-content-center" style={{ width: '33%' }}>
                              <button type="button" className="btn btn-primary" onClick={handleShow}>
                                {t("Upload")} {t("Documents")}
                              </button>
                            </div>
                          </div>
                        ):''
                      ) : (
                        <div className="text-center">
                          <h2>{t("Policy")} {t("Payment")} {t("Pending")}</h2>
                          <div>
                            <button
                              onClick={handleQotation}
                              style={{ marginLeft: 'auto', fontWeight: 'bold', backgroundColor: '#3fd2f2', color: 'white' }}
                            >
                              {t("Make Payment")}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </Col>
                  <Col md={2}></Col>
                </div>
              </div>
            </div>
      <Footer />

      {showUploadModal && (
        <div className="modal fade show" style={{ display: 'block' }} id="uploadModal">
          <div className="modal-dialog modal-dialog-centered modal-lg" style={{ left: '10%' }}>
            <div className="modal-content">
              <div className="modal-header">
                <h2 className="modal-title">
                  <span>
                    {t('Upload')} {t('Documents')}
                  </span>
                     {lnstr=="en"?<p style={{color:'red', marginLeft : '25px'}}>
                  Please upload a file format Pdf or Image.
                  </p>:<p style={{color:'red', marginLeft : '25px'}}>الرجاء تحميل ملف PDF أو صورة.</p>}
                </h2>
                <button type="button" className="close" onClick={handleClose}>
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <form onSubmit={(e) => handleUpload(e).then(handleClose)}>
                  <div className="form-group row">
                    <label className="col-sm-12 col-md-8 col-form-label text-left">
                    <strong>{t('Passport copy With visa page or Resident ID')}</strong>
                      {/* <strong>{t('Passport copy ')}</strong>
                      <br /> <small>{t('(Attach the visa page or resident ID)')}</small> */}
                    </label>
                    <div className="col-sm-12 col-md-4">
                      {passportFile === null ? (
                        <button className="btn btn-primary" type="button" onClick={() => document.getElementById('passport').click()}>
                          {t('Upload')} {t('File')}
                        </button>
                      ) : (
                        <div className="d-flex border mt-2 align-items-center p-2 rounded">
                          <p className="mb-0" style={{ width: '80%' }}>
                            {passportFile.name.length > 5
                              ? `${passportFile.name.substring(0, 5)}...${passportFile.type.split('/')[1]}`
                              : passportFile.name}
                          </p>
                          <span
                            className="text-danger ms-auto"
                            onClick={handleFileDelete}
                            data-name="passport"
                            style={{ cursor: 'pointer', width: '20%' }}>
                            &times;
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="form-group row mt-3">
                    <label className="col-sm-12 col-md-8 col-form-label text-left">
                      <strong>{t('Sponsor ResidentId Or Passport With VisaPage')}</strong>
                    </label>
                    <div className="col-sm-12 col-md-4">
                      {questionnaireFile === null ? (
                        <button className="btn btn-primary" type="button" onClick={() => document.getElementById('questionnaire').click()}>
                         {t('Upload')} {t('File')}
                        </button>
                      ) : (
                        <div className="d-flex border mt-2 align-items-center p-2 rounded">
                          <p className="mb-0" style={{ width: '80%' }}>
                            {questionnaireFile.name.length > 5
                              ? `${questionnaireFile.name.substring(0, 5)}...${questionnaireFile.type.split('/')[1]}`
                              : questionnaireFile.name}
                          </p>
                          <span
                            className="text-danger ms-auto"
                            onClick={handleFileDelete}
                            data-name="questionnaire"
                            style={{ cursor: 'pointer', width: '20%' }}>
                            &times;
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  <input
                    type="file"
                    name="passport"
                    id="passport"
                    accept="application/pdf,image/*"
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                  />
                  <input
                    type="file"
                    name="questionnaire"
                    id="questionnaire"
                    accept="application/pdf,image/*"
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                  />

                  <div className="mt-4 text-center">
                    <button type="submit" disabled={fileChoosen} className="btn btn-primary">
                      {t('Submit')}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

    </Fragment>
  );
}

export default MedicalAffordableDownload;